import { css } from 'lit';
export default css `
  wui-icon-box {
    height: 64px;
    width: 64px;
  }
`;
//# sourceMappingURL=styles.js.map